import script from "./CaskBadgeTips.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskBadgeTips.vue?vue&type=script&setup=true&lang=js"

import "./CaskBadgeTips.vue?vue&type=style&index=0&id=65bbb707&lang=scss"

const __exports__ = script;

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon,QTooltip});
